module.exports = __webpack_public_path__ + "static/media/s14.a97fa857.png";